import { render, staticRenderFns } from "./PersonalizedConfiguration.vue?vue&type=template&id=ffcb3fc0&scoped=true"
import script from "./PersonalizedConfiguration.vue?vue&type=script&lang=js"
export * from "./PersonalizedConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedConfiguration.vue?vue&type=style&index=0&id=ffcb3fc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb3fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffcb3fc0')) {
      api.createRecord('ffcb3fc0', component.options)
    } else {
      api.reload('ffcb3fc0', component.options)
    }
    module.hot.accept("./PersonalizedConfiguration.vue?vue&type=template&id=ffcb3fc0&scoped=true", function () {
      api.rerender('ffcb3fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/BeginnerCourse/components/PersonalizedConfiguration.vue"
export default component.exports